import { VirtualizedTableItem } from 'services/virtualizedTable/types';
import { Calibration, EquipmentSet } from 'services/equipmentSets/types';
import orderBy from 'lodash.orderby';
import get from 'lodash.get';
import set from 'lodash.set';

type CalibrationWithIndex = Calibration & { orderIndex: number };

export function validateEquipmentSetRow(
    item: VirtualizedTableItem<EquipmentSet>
): Record<string, any> | undefined {
    const { calibrations } = item;
    const errors: Record<string, any> = {};

    if (calibrations) {
        // Attach index as orderIndex for use in creating the correct structure to the errors object
        const calibrationsWithIndex: CalibrationWithIndex[] = calibrations.map(
            (calibration, index) => ({
                ...calibration,
                orderIndex: index
            })
        );

        const orderedCalibrations = orderBy<CalibrationWithIndex>(
            calibrationsWithIndex,
            ['applicationRate', 'rowSpacingMin']
        );

        orderedCalibrations.forEach((calibration, index) => {
            const previousCalibrationRowSpacingMax = get(orderedCalibrations, [
                index - 1,
                'rowSpacingMax'
            ]);
            const previousCalibrationApplicationRate = get(
                orderedCalibrations,
                [index - 1, 'applicationRate']
            );
            const nextCalibrationRowSpacingMin = get(orderedCalibrations, [
                index + 1,
                'rowSpacingMin'
            ]);
            const nextCalibrationApplicationRate = get(orderedCalibrations, [
                index + 1,
                'applicationRate'
            ]);

            const {
                rowSpacingMin,
                rowSpacingMax,
                applicationRate,
                orderIndex,
                swathWidth
            } = calibration;

            if (rowSpacingMax < rowSpacingMin) {
                set(
                    errors,
                    ['calibrations', orderIndex, 'rowSpacingMax'],
                    "Max Row Width can't be less than Min Row Width"
                );
            }

            if (
                applicationRate === previousCalibrationApplicationRate &&
                rowSpacingMin <= previousCalibrationRowSpacingMax
            ) {
                set(
                    errors,
                    ['calibrations', orderIndex, 'rowSpacingMin'],
                    'prev overlap'
                );
            }

            if (
                applicationRate === nextCalibrationApplicationRate &&
                rowSpacingMax >= nextCalibrationRowSpacingMin
            ) {
                set(
                    errors,
                    ['calibrations', orderIndex, 'rowSpacingMax'],
                    'next overlap'
                );
            }

            if (swathWidth && swathWidth > rowSpacingMin) {
                set(
                    errors,
                    ['calibrations', orderIndex, 'swathWidth'],
                    "Swath Width can't be greater than Min Row Width"
                );
            }
        });
    }

    return errors;
}
